import { DynamicStandaloneTextTitle } from '@/components/TextTitle';
import { LabradorComponent } from '@/types/component';
import { getLabStylingClasses } from '@/utils/getLabStylingClasses';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTextTitle: LabradorComponent = ({ type, meta, data }) => {
  const title = data.title;
  const titleStylingClasses = data.fieldSettings.title;
  const className = getLabStylingClasses(titleStylingClasses);
  return (
    <DynamicStandaloneTextTitle
      title={title}
      options={{ className: className }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTextTitle;
